import { render, staticRenderFns } from "./ChatsClientesIndex.vue?vue&type=template&id=903e6daa&"
import script from "./ChatsClientesIndex.vue?vue&type=script&lang=js&"
export * from "./ChatsClientesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports